module.exports = __webpack_public_path__ + "static/item--chloe--f3@3x.07da2898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--chloe--f3@3x.png
// module id = 637
// module chunks = 126511778744290